<style>
  #main {
    display: inline-block;
    width: 100%;
    position: relative;
    height: 650px;
  }

  #big {
    /*overflow: hidden;*/
  }

  #big, div.jQBracket {
    /*overflow: scroll!important;*/
  }

  .demo {
    overflow: auto;
    width: 100%;
    position: relative;
    height: 650px;
  }

  div.jQBracket {
    overflow: hidden;
    /*margin: 0 auto;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*/!* left: 50%; *!/*/
    /*/!* width: 100%; *!/*/
    /*transform: translate(0%,-50%);*/
    /*text-align: center;*/
  }

  div.jQBracket .team.win div.score {
    /*color: red!important;*/
    /*width: 0!important;*/
    /*opacity: 0;*/
    width: 35px !important;
  }

  div.jQBracket .team.lose div.score {
    /*color: #000!important;*/
    /*width: 0!important;*/
    /*opacity: 0;*/
    width: 35px !important;
  }

  .bubble {
    opacity: 0;
  }

  div.jQBracket .team div.label {
    /*width: 100%!important;*/
    /*text-align: center;*/
    /*text-align: center;*/
    line-height: 17px;
    width: 75% !important;
    overflow: hidden;
    white-space: nowrap;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
  }

  div.jQBracket .team.highlight {
    /*background-color:red!important;*/
  }

  .first {
    display: inline-block;
  }

  .first p {
    width: 100px;
    height: 22px;
  }

  div.jQBracket .team div.score {
    width: 35px !important;
  }

  .dy {
    width: 300px;
  }
</style>
<template>

  <div id="main">
    <div id="big"></div>
  </div>
</template>
<!--<link rel="stylesheet" href="./css/jquery.bracket.min.css"/>-->
<!--<script src="./js/jquery.js"></script>-->
<script src="./js/jquery.bracket.min.js"></script>
<script>
  export default {
//    props: ["matchData"],
    components: {},
    data()
  {
    return {
      ddd: "",
      skipSecondaryFinal: false,
    }
  }
  ,
  mounted()
  {
    let _this = this;
    $(function () {
      var demos = ['big']
      $.each(demos, function (i, d) {
        var demo = $('div#' + d)
        $('<div class="demo"></div>').appendTo(demo)
        var pre = $('<pre name="code" class="js"></pre>').appendTo(demo)
        var script = demo.find('script')
        demo.find("h3").append($('<a href="#' + d + '">¶</a>'))
        pre.text(script.html())
      })
    })

    var eightTeams = {
      "code":200,
      "description":"操作成功",
      "data":{
        "teams":[
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
          ["", ""],
        ],
        results : [[
              [[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],]
          ],
          [

          ],
          [

          ]
        ]
      },
      "serverTime":1564623605
    }
    var bigData = eightTeams.data
//    var bigData=_this.matchData.gameAgainst
//    console.log(_this.matchData)

    $(function () {
      //判断单败
//      if (_this.matchData.matchRule== 1) {
//        _this.skipSecondaryFinal = false;
//      } else {
//        _this.skipSecondaryFinal = true;
//      }
      $('div#big .demo').bracket({
        teamWidth: 10,
        scoreWidth: 150,
        matchMargin: 20,
        roundMargin: 100,
        clientTop: 20,
        centerConnectors: true,  //是否开启双引导线
        disableHighlight: false,  //是否关闭高亮冠军队伍 鼠标划入样式（css删除）
        skipConsolationRound: true, //关闭第三名第四名
        skipGrandFinalComeback: false, //是否关闭双败
        skipSecondaryFinal: _this.skipSecondaryFinal, //在双重淘汰赛中，禁用次要决赛
        onMatchClick: onclick,
//          onMatchHover: onhover,
        init: bigData
      })
      var big = $('#big div.demo')
      big.scrollLeft(1250)
//      if (bigData.teams.length == 16 && _this.matchData.matchRule== 2) {
//        big.scrollLeft(750)
//      }
//      if (bigData.teams.length == 8 && _this.matchData.matchRule== 2) {
//        big.scrollLeft(500)
//      }
      function onclick(data) {
        if (data) {
          _this.ddd = data
          alert(_this.ddd)
        }
      }
    })
  }
  ,
  methods:{

  }
  ,
  }
</script>



// WEBPACK FOOTER //
// src/components/bracket/index.vue